module.exports = __webpack_public_path__ + "img/23-help-huddle--swap.c199c768.png";